<template>
  <ViewCustomData entityName="property_type_conversion" entitySpec="d" serviceName="BaseService"
    :columns="PROPERTY_TYPE_CONVERSION_COLUMNS" scrollHeight="170px" :paginator="false" mode="edit"
    :masterDetail="masterDetail" :requiredFieldsTable="{
      property_outvalue: true,
      property_outvalue_text: true,
      event_group_id: true,
    }" :dictionary="PROPERTY_TYPE_CONVERSION_DICTIONARY" :prepareInsert="prepareInsert"
    :prepareUpdate="prepareUpdate" />
</template>

<script setup>
import { computed, ref, defineProps } from 'vue'
import {
  PROPERTY_TYPE_CONVERSION_DICTIONARY, PROPERTY_TYPE_CONVERSION_COLUMNS,
} from './propertyConstants'

const props = defineProps({
  propertyType: {
    type: Object,
    default: () => ({}),
  },
})

const selected = ref(null)

const masterDetail = computed(() => {
  if (
    props.propertyType?.property_type_id &&
    props.propertyType?.property_type_id > -1
  ) {
    return { property_type_id: props.propertyType.property_type_id };
  }
  return { property_type_id: -1 };
})

const prepareInsert = (rowData) => {
  const row = {
    property_type_conversion_id: null,
    property_type_id: masterDetail.value.property_type_id,
    property_outvalue: rowData.property_outvalue,
    property_outvalue_text: rowData.property_outvalue_text,
    event_group_id: rowData.event_group_id,
  };
  return row;
}

const prepareUpdate = (rowData) => {
  const row = {
    property_type_conversion_id: rowData.property_type_conversion_id,
    property_type_id: rowData.property_type_id,
    property_outvalue: rowData.property_outvalue,
    property_outvalue_text: rowData.property_outvalue_text,
    event_group_id: rowData.event_group_id,
  };
  return row;
}
</script>